import React from "react";

/* Animated voice waveform — purely CSS-driven bars */
export default function Waveform({ bars = 28, color = "#C2410C", active = true }) {
  const arr = Array.from({ length: bars });
  return (
    <div className="flex items-center justify-center h-12" aria-hidden>
      {arr.map((_, i) => (
        <span
          key={i}
          className="wsh-bar"
          style={{
            height: 40,
            background: color,
            animationDelay: `${(i * 80) % 1100}ms`,
            animationPlayState: active ? "running" : "paused",
            opacity: active ? 1 : 0.35,
          }}
        />
      ))}
    </div>
  );
}
